import React, { Fragment, useEffect, useState } from 'react';
import './plan-page.component.scss';
import {
  fetchLeadDetail,
  fetchPlans,
  addDslConnectionDetails,
  updateDslConnectionDetails,
  getLeadTokenVale,
  getPlansForKAM,
  getRouterList,
  getSavedPlan,
  submitLeadDetails,
  getCommercialAttributesList,
  checkOftFeasibilityStatusDedicated
} from '../../../../../src/common/helper/api.helper';
import {
  INITIATE_FETCHING,
  FETCH_SUCCESS,
  FETCH_ERROR,
  DEFAULT_1_MONTH_PLAN,
  MODULE_ID,
  SELECTED_PLAN,
  JOURNEY_STEPS_INDEX,
  CUSTOMER_DETAIL,
  FEASIBILITY_RESPONSE,
  DEDICATED_FEASIBILITY_RESPONSE,
  DEDICATED_CUSTOMER_DETAIL,
  AUTHORIZATION_HEADER,
  LEAD_STATUS,
  LEAD_STATUS_MSG,
  PNQ_AUTHORIZATION_HEADER,
  ROUTER_LISTS,
  contractOptions,
  POPUP_DATA,
  AVAILABLE_BANDWIDTH,
  INSTALLATION_PAGE_CUSTOMER_DETAIL,
  FEASIBILITY_DATA,
  DEDICATED_FEASIBILITY_DATA,
  DEDICATED_INSTALLATION_PAGE_CUSTOMER_DETAIL,
  AUTHORIZED_SIGNATORY,
  SUMMARY_AUTHORIZATION_HEADER,
  CAPEX_MEDIA_TYPE,
  SELECTED_PARTY_ACCOUNT,
  SELECTED_PARTY_DATA,
  FEASIBILITY_STATUS
} from '../../../common/constants/constants';
import MainLoader from 'b2b-ui-components-lib/lib/components/roundLoader';
import ToastComponent from '../../../../common/components/toast/toast.component';
import {
  scrollToTop,
  getFromSessionStorage,
  setInSessionStorage,
  removeFromSessionStorage,
  navigateTo,
  findParamFromUrl,
  convertBandwidthInMbps,
  removeConfirmOrderStorage,
  unAuthPlanPageGtags,
  disableBrowserBackButton,
  removeEmptyValuesObj
} from '../../../../common/utils/app.utils';
import StepsHeader from '../steps-header/steps.component';
import Plan from '../plan/plan.component';
import Quotation from '../../../../dedicated/components/quotation/Quotation';
import Button from 'b2b-ui-components-lib/lib/components/button';
import { PRODUCT_NAME, PRODUCT_TYPE, ROUTES, PLAN_PAGE_NOTIFICATIONS } from '../../../../common/constants/app.constants';
import useApiHook from '../../customHook/apiHook';
import { fireAnalyticsOnChoosePlanPageLoad, fireAnalyticsOnProceedPlanButtonClick } from '../../../../common/services/analytics';
import DedicatedPlanPage from '../../../../dedicated/components/choose-plan/Plan';
import { faOnDedicatedAuthPlanPageLoad, faOnDedicatedUnauthPlanPageLoad } from '../../../../dedicated/services/analytics.service';
import queryString from 'query-string';
import config from '../../../../config/config';
import PopupComponent from '../../../../dedicated/components/pop-up/popup.component';
import { SUCCESS_TOAST, ERROR_TOAST, WARNING_TOAST } from 'home/view/manage-feasibility/constants';
import { getNotificationType } from 'common/utils/app.utils';
// import { Notification } from 'common/components/notification-component/notification-component';
import { Notification } from 'featureLib/NotificationComponent';
import { fetchRateCardIdList } from 'home/view/manage-feasibility/services';

let aehToken = localStorage.getItem('accessToken') ? localStorage.getItem('accessToken') : '';
let toastMessageValue = '';
const PlanPage = (props) => {
  const partyId = findParamFromUrl('partyId', false);

  let { changePlan } = props;
  let { isProductPage } = props;
  let existingPlanDetails = getFromSessionStorage(MODULE_ID, SELECTED_PLAN);
  const [plans, setPlans] = useState([]);
  const [callPlanDetails, setCallPlanDetails] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState({});
  const [showNetworkConverage, setNetorkConverageStatus] = useState(true);

  const [fetchState, setAPIFetechingState] = useApiHook();
  const [pincode, setpincode] = useState('');
  const [activeStep, setactiveStep] = useState(0);
  let [servicetype, setservicetype] = useState();
  let [productName, setProductName] = useState();
  let [kamDetails, setKamDetails] = useState({});
  let [leadStatus, setLeadStatus] = useState('');
  let [leadDetails, setLeadDetails] = useState({});
  let [getLeadPlan, setLeadPlan] = useState(null);
  let [userType, setuserType] = useState('KAM');
  let [paramsValue, setParamsValue] = useState(null);
  const [showToastMessage, setToastMessage] = useState(false);
  let [routerLists, setRouterLists] = useState({});
  let [pnqLeadData, setPnqLeadData] = useState('');
  let [showCustomPopup, setShowCustomPopup] = useState(false);
  let [commercialAttribute, setCommercialAttributes] = useState({});
  let [dualLastMile, setDualLastMile] = useState(false);
  const [feasibilityData, setFeasibilityData] = useState({});
  const [selectedPrimaryMedia, setSelectedPrimaryMedia] = useState({});
  const [itemCode, setItemCode] = useState('');
  const [rateCardIdList, setRateCardIdList] = useState([]);
  const [selectedRateCardId, setSelectedRateCardId] = useState({});

  const getLeadTokenValue = (partyId, leadId, user, getParams) => {
    removeFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER);
    setAPIFetechingState({ type: INITIATE_FETCHING });
    let payLoad = {};
    payLoad.partyId = partyId;
    payLoad.leadId = leadId;
    payLoad.aehAccessToken = aehToken;
    let pnqToken = user && user === 'KAM' ? true : false;
    if (pnqToken) {
      payLoad.pnqToken = pnqToken;
    }
    getLeadTokenVale(payLoad)
      .then((response) => {
        let data = response && response.data;
        setAPIFetechingState({ type: FETCH_SUCCESS });
        let auth_token =
          response && response.headers && response.headers.authorization_token
            ? response.headers.authorization_token
            : response && response.headers && response.headers.authorization;
        if (auth_token && pnqToken) {
          setInSessionStorage(MODULE_ID, PNQ_AUTHORIZATION_HEADER, auth_token);
          getRouterData(auth_token, getParams);
        } else if (auth_token) {
          setInSessionStorage(MODULE_ID, AUTHORIZATION_HEADER, auth_token);
          onLoadData();
        }
      })
      .catch((err) => {
        setAPIFetechingState({ type: FETCH_SUCCESS });
        // let auth_token='eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJQTlFJTEwyMjEyMjE4NTUzMixLQU0iLCJpYXQiOjE2NDAxNjM1NDcsImV4cCI6MTY0MDI0OTk0N30.-rXvodaCLFX9EML0RhTDJSj0hSpH1XmhZKh0ZCMdQ8FCLkNC2ei3nrflThDVYVzfA6-d4n9S820av8JtYT1hXQ';
        // setInSessionStorage(MODULE_ID, PNQ_AUTHORIZATION_HEADER, auth_token);
        // getRouterData(auth_token,getParams);
      });
  };
  const onLoadData = () => {
    setAPIFetechingState({ type: INITIATE_FETCHING });
    let customerDetails = props.isdedicatedJourney ? getFromSessionStorage(MODULE_ID, DEDICATED_CUSTOMER_DETAIL) : getFromSessionStorage(MODULE_ID, CUSTOMER_DETAIL);
    let feasibilityResponse;
    let installationPincode = customerDetails && customerDetails.installationPincode;
    feasibilityResponse = props.isdedicatedJourney ? getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE) : getFromSessionStorage(MODULE_ID, FEASIBILITY_RESPONSE);
    let pinCode = feasibilityResponse && feasibilityResponse.address && feasibilityResponse.address.pinCode ? feasibilityResponse.address.pinCode : installationPincode;
    setpincode(pinCode);
    fetchLead(undefined, feasibilityResponse);
  };
  useEffect(() => {
    let getParams = queryString.parse(window && window.location.search);
    let platform = getParams && getParams.platform;
    let partyId = getParams && getParams.partyId;
    let leadId = getParams && getParams.leadId;
    let user = getParams && getParams.user;
    setParamsValue(getParams);
    scrollToTop();
    disableBrowserBackButton();
    removeFromSessionStorage(MODULE_ID, ROUTER_LISTS);
    let getPnQAuthHeader = getFromSessionStorage(MODULE_ID, PNQ_AUTHORIZATION_HEADER);
    if (platform === 'AEH' && partyId && leadId && !getPnQAuthHeader) {
      getLeadTokenValue(partyId, leadId, user, getParams);
    } else if (getPnQAuthHeader) {
      getRouterData(getPnQAuthHeader, getParams);
    } else {
      onLoadData();
    }
    if (getFromSessionStorage(MODULE_ID, PRODUCT_NAME) !== PRODUCT_TYPE.VPN && props.isUnAuthJourney) {
      unAuthPlanPageGtags();
    }
  }, []);

  useEffect(() => {
    const feasibilityId = leadDetails && leadDetails.feasibilityId;
    const { isdedicatedJourney } = props;
    const kamLineItemData = (pnqLeadData && Array.isArray(pnqLeadData) && pnqLeadData.length > 0 && pnqLeadData[0]) || null;
    const kamFeasibilityResponse =
      (kamLineItemData &&
        Array.isArray(kamLineItemData.lineItems) &&
        kamLineItemData.lineItems.length > 0 &&
        kamLineItemData.lineItems[0] &&
        kamLineItemData.lineItems[0].plan &&
        Array.isArray(kamLineItemData.lineItems[0].plan.site) &&
        kamLineItemData.lineItems[0].plan.site.length > 0 &&
        kamLineItemData.lineItems[0].plan.site[0] &&
        kamLineItemData.lineItems[0].plan.site[0].feasibilityResponse) ||
      {};
    // get feasibility response in case of TMO redirect to PnQ step

    if (feasibilityId && isdedicatedJourney) {
      const feasibilityResponse = getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE) || kamFeasibilityResponse;

      if (!feasibilityResponse) {
        checkOftFeasibilityStatusDedicated({ feasibilityId }).then((res) => {
          const resData = res && res.data && res.data.result[0];
          setFeasibilityData(resData);
          setInSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE, resData);
        });
      } else {
        setFeasibilityData(feasibilityResponse);
      }
    }
  }, [leadDetails, pnqLeadData]);

  const commercialAttributesList = (productName) => {
    setAPIFetechingState({ type: INITIATE_FETCHING });
    let payload = {};
    payload.configFields = 'COMMERCIAL_ATTRIBUTE';
    payload.productType = productName ? productName : PRODUCT_TYPE.DEDICATED_INTERNET;
    getCommercialAttributesList(payload)
      .then((response) => {
        let responseData = response && response.data && response.data.result && response.data.result.commercialAttributes;
        responseData &&
          responseData.cpeSpecification &&
          Object.keys(responseData.cpeSpecification).length > 0 &&
          Object.keys(responseData.cpeSpecification).map(function (key, index) {
            responseData.cpeSpecification[key].length > 0 &&
              responseData.cpeSpecification[key].map((item, index) => {
                let updateList = {};
                updateList.model = item;
                updateList.cost = '';
                updateList.commercial = true;
                updateList.linkType = 'PRIMARY';
                responseData.cpeSpecification[key][index] = updateList;
              });
          });
        setAPIFetechingState({ type: FETCH_SUCCESS });
        setCommercialAttributes(responseData);
      })
      .catch((err) => {
        setAPIFetechingState({ type: FETCH_SUCCESS });
      });
  };

  const getKamLeadData = (auth_token, getParams, statusValue) => {
    if (getParams && getParams.user == 'KAM') {
      let payload = {
        leadId: getParams.leadId,
        userType: 'KAM',
        skipStatus: true
      };
      let pnqToken = localStorage.getItem('accessToken');
      setAPIFetechingState({ type: INITIATE_FETCHING });
      getSavedPlan(payload, pnqToken)
        .then((res) => {
          if (!auth_token) {
            auth_token = getFromSessionStorage(MODULE_ID, PNQ_AUTHORIZATION_HEADER);
          }
          let getPnqLeadData = res && res.data && res.data.result && res.data.result.leads;
          let redirectUrl = '';
          if (getPnqLeadData && getPnqLeadData.length > 0) {
            let leadData = getPnqLeadData && getPnqLeadData.length && getPnqLeadData[0];
            let leadStats = leadData && leadData.leadStatus;
            const siteSpecs = leadData?.lineItems?.[0]?.plan?.site?.[0]?.siteSpecs;
            // setItemCode

            if (siteSpecs?.length > 0) {
              const itemCodeSpecItem = siteSpecs?.find((item) => item.name === 'itemCode');

              if (itemCodeSpecItem?.value) {
                setItemCode(itemCodeSpecItem?.value);
              }
            }

            if (leadStats === LEAD_STATUS.PRICING_DOA_REJECTED && leadData && leadData.doaStatus === 'REJECTED') {
              toggelToastPopup();
              redirectUrl = ROUTES.DEDICATED_CANCEL;
              if (partyId) {
                redirectUrl = redirectUrl + '?partyId=' + partyId;
              }
              props.history &&
                props.history.push(redirectUrl, {
                  userType: 'KAM',
                  reason: '',
                  orderId: leadData.leadId,
                  doaStatus: leadData.doaStatus
                });
            } else if (leadStats === LEAD_STATUS.LEAD_SUBMITTED) {
              redirectUrl = ROUTES.DEDICATED_THANK_YOU;
              if (partyId) {
                redirectUrl = redirectUrl + '?partyId=' + partyId;
              }
              props.history &&
                props.history.push(redirectUrl, {
                  leadId: leadData.leadId,
                  userType: 'KAM'
                });
            } else if (leadStats === LEAD_STATUS.FEASIBILITY_COMPLETED && leadData.feasibilityStatus === 'NOT_FEASIBLE') {
              redirectUrl = ROUTES.DEDICATED_THANK_YOU;
              if (partyId) {
                redirectUrl = redirectUrl + '?partyId=' + partyId;
              }
              props.history &&
                props.history.push(redirectUrl, {
                  leadId: leadData.leadId,
                  noNetwork: true
                });
            } else if (leadStats === LEAD_STATUS.PNQ_CANCELED) {
              toggelToastPopup();
              redirectUrl = ROUTES.DEDICATED_CANCEL;
              if (partyId) {
                redirectUrl = redirectUrl + '?partyId=' + partyId;
              }
              props.history &&
                props.history.push(redirectUrl, {
                  reason: '',
                  orderId: leadData.leadId
                });
            } else {
              let subProductName = leadData && leadData.lineItems && leadData.lineItems.length > 0 && leadData.lineItems[0] && leadData.lineItems[0].subProductName;
              let getProductName = leadData && leadData.lineItems && leadData.lineItems.length > 0 && leadData.lineItems[0] && leadData.lineItems[0].productName;
              let productName = getProductName === 'MPLS' ? PRODUCT_TYPE.VPN : PRODUCT_TYPE.DEDICATED_INTERNET;
              commercialAttributesList(productName);
              if (productName) {
                setInSessionStorage(MODULE_ID, PRODUCT_NAME, productName);
              }
              let data =
                leadData &&
                leadData.lineItems &&
                leadData.lineItems.length > 0 &&
                leadData.lineItems[0] &&
                leadData.lineItems[0].plan &&
                leadData.lineItems[0].plan.site &&
                leadData.lineItems[0].plan.site.length > 0 &&
                leadData.lineItems[0].plan.site[0] &&
                leadData.lineItems[0].plan.site[0].feasibilityResponse;
              let mediatype =
                data && data.wirelineNetworkElement && data.wirelineNetworkElement.media
                  ? data.wirelineNetworkElement.media
                  : data && data.wirelessNetworkElement && data.wirelessNetworkElement.technology;
              let maxBandwidth =
                data && data.maxBandwidth
                  ? data.maxBandwidth
                  : data && data.wirelineNetworkElement && data.wirelineNetworkElement.maxBandwidth
                  ? data.wirelineNetworkElement.maxBandwidth
                  : data && data.wirelessNetworkElement && data.wirelessNetworkElement.maxBandwidth;
              if (data && data.wirelineNetworkElement && data.wirelineNetworkElement.media) {
                mediatype = data.wirelineNetworkElement.media;
              } else if (data && data.offNetResponse && data.offNetResponse.offNetStatus) {
                mediatype = CAPEX_MEDIA_TYPE.offnet;
              } else if (data && data.thirdPartyResponse && Object.keys(data.thirdPartyResponse).length > 0) {
                mediatype = CAPEX_MEDIA_TYPE.thirdParty;
              } else if (data && data.wirelessNetworkElement && data.wirelessNetworkElement.technology) {
                mediatype = data.wirelessNetworkElement.technology;
              }
              if (data && Object.keys(data).length > 0) {
                setInSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE, data);
              }

              setDualLastMile(data && data.dualLastMile ? true : false);
              localStorage.setItem('media', mediatype);
              localStorage.setItem('maxBandwidth', maxBandwidth);
              setLeadStatus(leadStats);
              setPnqLeadData(getPnqLeadData);
              setProductName(getProductName);
              if (subProductName) {
                setservicetype(subProductName);
              } else {
                setservicetype('MANAGED');
              }
              setAPIFetechingState({ type: FETCH_SUCCESS });
              let callToggelToastPopup = checkToggelToastPopup(leadData, true);
              if (callToggelToastPopup) {
                toggelToastPopup();
              }
            }
          } else {
            redirectUrl = ROUTES.DEDICATED_THANK_YOU;
            if (partyId) {
              redirectUrl = redirectUrl + '?partyId=' + partyId;
            }
            props.history &&
              props.history.push(redirectUrl, {
                leadId: 'KAM',
                userType: 'KAM'
              });
          }
        })
        .catch((err) => {
          setAPIFetechingState({ type: FETCH_SUCCESS });
          console.log(err);
        });
    }
  };

  const fetchPlansOrKAMData = (extraPayload = {}) => {
    extraPayload = removeEmptyValuesObj(extraPayload);
    let feasibilityResponse = props.isdedicatedJourney ? getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE) : getFromSessionStorage(MODULE_ID, FEASIBILITY_RESPONSE);
    let auth_token = getFromSessionStorage(MODULE_ID, PNQ_AUTHORIZATION_HEADER);
    let pinCode = feasibilityResponse && feasibilityResponse.address && feasibilityResponse.address.pinCode;
    setpincode(pinCode);
    let getParams = queryString.parse(window && window.location.search);
    let user = getParams && getParams.user;
    if (user !== 'KAM' && servicetype) {
      fetchAllPlans(pinCode, extraPayload);
    } else if (user === 'KAM' && auth_token && servicetype) {
      let kamPayload = { ...extraPayload, rateCardId: pnqLeadData?.[0]?.rateCardId };
      fetchKamData(auth_token, servicetype, productName, kamPayload);
    }
  };

  //const setCallPlanDetails
  useEffect(() => {
    if (callPlanDetails) {
      if (!changePlan) {
        addPlanDetails();
      } else {
        updatePlanDetails();
      }
    }
  }, [callPlanDetails]);

  useEffect(() => {
    const id = setTimeout(() => {
      fetchPlansOrKAMData({ media: selectedPrimaryMedia?.id, rateCardId: selectedRateCardId?.key });
    }, 200);

    return () => clearTimeout(id);
  }, [servicetype, selectedPrimaryMedia?.id, selectedRateCardId?.key]);

  const handleRateCard = (rateCardId) => {
    setAPIFetechingState({ type: INITIATE_FETCHING });

    fetchRateCardIdList()
      .then((res) => {
        setAPIFetechingState({ type: FETCH_SUCCESS });
        if (res?.data?.success && res?.data?.result?.rateCardIdList) {
          const updatedRateCardIdList = res.data.result.rateCardIdList.map((item) => {
            item['key'] = item.rfp_num;
            item['displayName'] = item.rfp_num;

            return item;
          });
          const selectedRateCardId = updatedRateCardIdList?.find((item) => item.rfp_num === rateCardId) || updatedRateCardIdList?.[0];

          setRateCardIdList(updatedRateCardIdList);
          setSelectedRateCardId(selectedRateCardId);
        }
      })
      .catch((err) => {
        setAPIFetechingState({ type: FETCH_SUCCESS });
        console.log(err);
      });
  };

  const fetchLead = (action, feasibilityResponse) => {
    console.log('action', action);
    console.log('PRODUCT_NAME', getFromSessionStorage(MODULE_ID, PRODUCT_NAME));

    const feasibilityRes = { ...feasibilityResponse };
    fetchLeadDetail(props.isdedicatedJourney)
      .then((response) => {
        let data = response && response.data && response.data.result;
        let redirectUrl = '';

        if (paramsValue?.user !== 'KAM') {
          handleRateCard(response?.data?.result?.rateCardId);
        }

        commercialAttributesList(data && data.serviceType);
        if (props.isdedicatedJourney) {
          const params = {
            feasibilityStatus: feasibilityRes && feasibilityRes.feasibilityStatus,
            leadId: data.leadId
          };
          if (props.isUnAuthJourney) {
            faOnDedicatedUnauthPlanPageLoad(params);
          }
          faOnDedicatedAuthPlanPageLoad(params);
        } else {
          fireAnalyticsOnChoosePlanPageLoad();
        }

        if (data && data.serviceType) {
          setInSessionStorage(MODULE_ID, PRODUCT_NAME, data.serviceType);
        }
        if (data && data.status === LEAD_STATUS.SUBMITTED) {
          redirectUrl = ROUTES.DEDICATED_THANK_YOU;
          let getSummaryToken = getFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER);
          if (data.customer && data.customer.segment === 'ENTERPRISE' && getSummaryToken) {
            redirectUrl = ROUTES.DEDICATED_SUMMARY;
          }
          const isSMBUser = data?.customer?.segment === 'SMB';
          const hideNetworkSteps = redirectUrl === ROUTES.DEDICATED_THANK_YOU && isSMBUser;
          if (partyId) {
            redirectUrl = redirectUrl + '?partyId=' + partyId;
          }
          props.history &&
            props.history.push(redirectUrl, {
              leadId: data.leadId,
              via: 'CHOOSE_PLAN',
              hideNetworkSteps
            });
        } else if (data && data.status === LEAD_STATUS.FEASIBILITY_COMPLETED && data.feasibilityStatus === 'NOT_FEASIBLE') {
          redirectUrl = ROUTES.DEDICATED_THANK_YOU;
          if (partyId) {
            redirectUrl = redirectUrl + '?partyId=' + partyId;
          }
          props.history &&
            props.history.push(redirectUrl, {
              leadId: data.leadId,
              noNetwork: true,
              via: 'CHOOSE_PLAN'
            });
        } else if (data && (data.status === LEAD_STATUS.PNQ_CANCELED || data.status === LEAD_STATUS.LEAD_CANCELED)) {
          toggelToastPopup();
          redirectUrl = ROUTES.DEDICATED_CANCEL;
          if (partyId) {
            redirectUrl = redirectUrl + '?partyId=' + partyId;
          }
          props.history && props.history.push(redirectUrl, { reason: '' });
        }

        if (data && data.serviceType) {
          setInSessionStorage(MODULE_ID, PRODUCT_NAME, data.serviceType);
        }
        let feasibilityResponse;
        feasibilityResponse = props.isdedicatedJourney ? getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE) : getFromSessionStorage(MODULE_ID, FEASIBILITY_RESPONSE);
        let pinCode = feasibilityResponse && feasibilityResponse.address && feasibilityResponse.address.pinCode;
        let installationPincode =
          data && data.internetLineItems && data.internetLineItems[0].address && data.internetLineItems[0].address.pincode ? data.internetLineItems[0].address.pincode : pinCode;
        let customerDetails = data && data.customer && data.customer.authorizedSignatory;
        customerDetails.installationPincode = installationPincode;
        props.isdedicatedJourney ? setInSessionStorage(MODULE_ID, DEDICATED_CUSTOMER_DETAIL, customerDetails) : setInSessionStorage(MODULE_ID, CUSTOMER_DETAIL, customerDetails);
        let dedicatedInternetLineItems = data && data.connectivityLineItems;
        let feasibilityResponseData =
          dedicatedInternetLineItems && dedicatedInternetLineItems.length > 0 && dedicatedInternetLineItems[0] && dedicatedInternetLineItems[0].feasibilityResponse;
        if (feasibilityResponseData && feasibilityResponseData.maxBandwidth) {
          localStorage.setItem('maxBandwidth', feasibilityResponseData.maxBandwidth);
        }
        let mediatype =
          feasibilityResponseData && feasibilityResponseData.wirelineNetworkElement && feasibilityResponseData.wirelineNetworkElement.media
            ? feasibilityResponseData.wirelineNetworkElement.media
            : feasibilityResponseData && feasibilityResponseData.wirelessNetworkElement && feasibilityResponseData.wirelessNetworkElement.technology
            ? feasibilityResponseData.wirelessNetworkElement.technology
            : feasibilityResponseData &&
              feasibilityResponseData.feasibilityType &&
              feasibilityResponseData.feasibilityType.length > 0 &&
              feasibilityResponseData.feasibilityType[0];
        if (feasibilityResponseData && feasibilityResponseData.wirelineNetworkElement && feasibilityResponseData.wirelineNetworkElement.media) {
          mediatype = feasibilityResponseData.wirelineNetworkElement.media;
        } else if (feasibilityResponseData && feasibilityResponseData.offNetResponse && feasibilityResponseData.offNetResponse.offNetStatus) {
          mediatype = CAPEX_MEDIA_TYPE.offnet;
        } else if (feasibilityResponseData && feasibilityResponseData.thirdPartyResponse && Object.keys(feasibilityResponseData.thirdPartyResponse).length > 0) {
          mediatype = CAPEX_MEDIA_TYPE.thirdParty;
        } else if (feasibilityResponseData && data.feasibilityResponseData && data.feasibilityResponseData.technology) {
          mediatype = data.wirelessNetworkElement.technology;
        }
        if (mediatype) {
          localStorage.setItem('media', mediatype);
        }
        if (feasibilityResponseData && Object.keys(feasibilityResponseData).length > 0) {
          setInSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE, feasibilityResponseData);
        }
        setDualLastMile(feasibilityResponseData && feasibilityResponseData.dualLastMile ? true : false);
        setpincode(installationPincode);
        setLeadStatus(data && data.status);
        let callToggelToastPopup = checkToggelToastPopup(data, false);
        if (callToggelToastPopup) {
          toggelToastPopup();
        }
        setKamDetails(data && data.customer && data.customer.kamDetails);
        setLeadDetails(data);
        if (dedicatedInternetLineItems && dedicatedInternetLineItems.length > 0 && dedicatedInternetLineItems[0] && dedicatedInternetLineItems[0].planDetail) {
          const routerSpecs = dedicatedInternetLineItems[0]?.planDetail?.routerSpecs;

          setservicetype(dedicatedInternetLineItems[0].planDetail.service);
          setLeadPlan(dedicatedInternetLineItems[0].planDetail);

          // setItemCode
          if (Array.isArray(routerSpecs) && routerSpecs?.length > 0) {
            routerSpecs?.forEach((item) => {
              if (item['make'] && item['model']) {
                setItemCode(item['itemCode']);
              }
            });
          }
        } else {
          setservicetype('MANAGED');
        }
        setAPIFetechingState({ type: FETCH_SUCCESS });
        if (action === 'SUBMIT_LEAD' && checkSubmitStatus(data)) {
          submitLead(data);
        } else if (data && data.status === LEAD_STATUS.KYC_COMPLETED) {
          redirectUrl = ROUTES.DEDICATED_HOME;
          if (partyId) {
            redirectUrl = redirectUrl + '?partyId=' + partyId;
          }
          removeFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER);
          removeFromSessionStorage(MODULE_ID, CUSTOMER_DETAIL);
          removeFromSessionStorage(MODULE_ID, INSTALLATION_PAGE_CUSTOMER_DETAIL);
          removeFromSessionStorage(MODULE_ID, FEASIBILITY_DATA);
          removeFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE);
          removeFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_DATA);
          removeFromSessionStorage(MODULE_ID, FEASIBILITY_RESPONSE);
          removeFromSessionStorage(MODULE_ID, DEDICATED_CUSTOMER_DETAIL);
          removeFromSessionStorage(MODULE_ID, DEDICATED_INSTALLATION_PAGE_CUSTOMER_DETAIL);
          removeFromSessionStorage(MODULE_ID, AUTHORIZED_SIGNATORY);
          removeFromSessionStorage(MODULE_ID, SELECTED_PARTY_ACCOUNT);
          removeFromSessionStorage(MODULE_ID, SELECTED_PARTY_DATA);
          removeFromSessionStorage(MODULE_ID, SUMMARY_AUTHORIZATION_HEADER);
          props.history && props.history.push(redirectUrl);
        } else {
          let feasibilityResponse;
          feasibilityResponse = props.isdedicatedJourney
            ? getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE)
            : getFromSessionStorage(MODULE_ID, FEASIBILITY_RESPONSE);
          let pinCode = feasibilityResponse && feasibilityResponse.address && feasibilityResponse.address.pinCode;
          let installationPincode =
            data && data.internetLineItems && data.internetLineItems[0].address && data.internetLineItems[0].address.pincode ? data.internetLineItems[0].address.pincode : pinCode;
          let customerDetails = data && data.customer && data.customer.authorizedSignatory;
          customerDetails.installationPincode = installationPincode;
          props.isdedicatedJourney ? setInSessionStorage(MODULE_ID, DEDICATED_CUSTOMER_DETAIL, customerDetails) : setInSessionStorage(MODULE_ID, CUSTOMER_DETAIL, customerDetails);
          let dedicatedInternetLineItems = data && data.connectivityLineItems;
          let feasibilityResponseData =
            dedicatedInternetLineItems && dedicatedInternetLineItems.length > 0 && dedicatedInternetLineItems[0] && dedicatedInternetLineItems[0].feasibilityResponse;
          if (feasibilityResponseData && feasibilityResponseData.maxBandwidth) {
            localStorage.setItem('maxBandwidth', feasibilityResponseData.maxBandwidth);
          }
          let mediatype =
            feasibilityResponseData && feasibilityResponseData.wirelineNetworkElement && feasibilityResponseData.wirelineNetworkElement.media
              ? feasibilityResponseData.wirelineNetworkElement.media
              : feasibilityResponseData && feasibilityResponseData.wirelessNetworkElement && feasibilityResponseData.wirelessNetworkElement.technology
              ? feasibilityResponseData.wirelessNetworkElement.technology
              : feasibilityResponseData &&
                feasibilityResponseData.feasibilityType &&
                feasibilityResponseData.feasibilityType.length > 0 &&
                feasibilityResponseData.feasibilityType[0];
          if (feasibilityResponseData && feasibilityResponseData.wirelineNetworkElement && feasibilityResponseData.wirelineNetworkElement.media) {
            mediatype = feasibilityResponseData.wirelineNetworkElement.media;
          } else if (feasibilityResponseData && feasibilityResponseData.offNetResponse && feasibilityResponseData.offNetResponse.offNetStatus) {
            mediatype = CAPEX_MEDIA_TYPE.offnet;
          } else if (feasibilityResponseData && feasibilityResponseData.thirdPartyResponse && Object.keys(feasibilityResponseData.thirdPartyResponse).length > 0) {
            mediatype = CAPEX_MEDIA_TYPE.thirdParty;
          } else if (feasibilityResponseData && data.feasibilityResponseData && data.feasibilityResponseData.technology) {
            mediatype = data.wirelessNetworkElement.technology;
          }
          if (mediatype) {
            localStorage.setItem('media', mediatype);
          }
          setpincode(installationPincode);
          setLeadStatus(data && data.status);
          let callToggelToastPopup = checkToggelToastPopup(data, false);
          if (callToggelToastPopup) {
            toggelToastPopup();
          }
          setKamDetails(data && data.customer && data.customer.kamDetails);
          setLeadDetails(data);
          if (dedicatedInternetLineItems && dedicatedInternetLineItems.length > 0 && dedicatedInternetLineItems[0] && dedicatedInternetLineItems[0].planDetail) {
            setservicetype(dedicatedInternetLineItems[0].planDetail.service);
            setLeadPlan(dedicatedInternetLineItems[0].planDetail);
          } else {
            setservicetype('MANAGED');
          }
          setAPIFetechingState({ type: FETCH_SUCCESS });
          if (action === 'SUBMIT_LEAD' && checkSubmitStatus(data)) {
            submitLead(data);
          }
        }
      })
      .catch((err) => {
        setAPIFetechingState({ type: FETCH_SUCCESS });
        handleAPIError(err);
      });
  };

  const checkSubmitStatus = (data) => {
    let status = false;
    if (data && (data.status.toUpperCase() === LEAD_STATUS.IN_PROGRESS || data.status.toUpperCase() === 'FEASIBILITY_COMPLETED')) {
      status = true;
    } else if (data && data.status.toUpperCase() === LEAD_STATUS.PNQ_COMPLETED && data.doaStatus === 'REJECTED') {
      return true;
    }
    return status;
  };

  const submitLead = (data) => {
    const customerSegment = data && data.customer && data.customer.segment;

    const redirectCb = (currentLeadId) => {
      let redirectUrl = ROUTES.DEDICATED_THANK_YOU;

      if (leadStatus && (leadStatus.toUpperCase() !== LEAD_STATUS.FEASIBILITY_PENDING || leadStatus.toUpperCase() !== LEAD_STATUS.PNQ_IN_PROGRESS)) {
        if (customerSegment === 'ENTERPRISE') {
          redirectUrl = ROUTES.DEDICATED_SUMMARY;
          if (partyId) {
            redirectUrl = redirectUrl + '?partyId=' + partyId;
          }
          props.history && props.history.push(redirectUrl);
        } else {
          if (partyId) {
            redirectUrl = redirectUrl + '?partyId=' + partyId;
          }
          removeConfirmOrderStorage();
          props.history &&
            props.history.push(redirectUrl, {
              leadId: currentLeadId,
              via: 'CHOOSE_PLAN',
              hideNetworkSteps: customerSegment === 'SMB' ? true : false
            });
        }
      }
    };

    if (customerSegment === 'ENTERPRISE') {
      redirectCb(data && data.leadId);
    } else {
      submitLeadDetails(true)
        .then((res) => {
          setAPIFetechingState({ type: FETCH_SUCCESS });
          redirectCb(res && res.data && res.data.result.leadId);
        })
        .catch((err) => {
          setAPIFetechingState({ type: FETCH_SUCCESS });
        });
    }
  };
  const fetchKamData = (authorization, subProductName, productName, extraPayload = {}) => {
    let KamPayload = {
      product: productName ? productName : 'INTERNET',
      service: subProductName ? subProductName : servicetype,
      ...extraPayload
    };
    let maxBandwidth = getMaxBandwidth();
    if (maxBandwidth) {
      KamPayload.maxBandwidth = maxBandwidth;
    }
    getPlansForKAM(KamPayload, authorization)
      .then((response) => {
        let responseData = response && response.data && response.data.result;
        let data = response && response.data;
        let updatedResponse =
          responseData &&
          responseData.length > 0 &&
          responseData.map((item, index) => {
            return {
              floorPrice: {
                amount: item.plan.prices.FLOOR_RATE.charge,
                otc: item.plan.prices.FLOOR_RATE.otc
              },
              price: {
                amount: item.plan.prices.RATE.charge,
                otc: item.plan.prices.RATE.otc
              },
              standardRate: item.plan.standardRate,
              speed: item.bandwidth,
              id: index,
              service: item.serviceType,
              contractPeriod: contractOptions[0],
              media: selectedPrimaryMedia
            };
          });
        data.success &&
          setPlans(
            data.result.map((item, index) => {
              return {
                floorPrice: {
                  amount: item.plan.prices.FLOOR_RATE.charge,
                  otc: item.plan.prices.FLOOR_RATE.otc
                },
                price: {
                  amount: item.plan.prices.RATE.charge,
                  otc: item.plan.prices.RATE.otc
                },
                standardRate: item.plan.standardRate,
                speed: item.bandwidth,
                id: index,
                service: item.serviceType,
                contractPeriod: contractOptions[0],
                media: selectedPrimaryMedia
              };
            })
          );
        setAPIFetechingState({ type: FETCH_SUCCESS });
        setInSessionStorage(MODULE_ID, AVAILABLE_BANDWIDTH, convertBandwidthInMbps(updatedResponse));
      })
      .catch((err) => {
        setAPIFetechingState({ type: FETCH_SUCCESS });
        handleAPIError(err);
      });
  };
  const addPlanDetails = () => {
    fireAnalyticsOnProceedPlanButtonClick();
    setAPIFetechingState({ type: INITIATE_FETCHING });
    let feasibilityResponse = getFromSessionStorage(MODULE_ID, FEASIBILITY_RESPONSE);
    let finalPayload = [];
    let connectionDetails = getFromSessionStorage(MODULE_ID, CUSTOMER_DETAIL);

    connectionDetails.planDetail = createPlanDetails();
    connectionDetails.feasibilityId = feasibilityResponse.feasibilityId;
    connectionDetails.feasibilityStatus = feasibilityResponse.feasibilityStatus;

    finalPayload.push(connectionDetails);
    addDslConnectionDetails(finalPayload)
      .then((response) => {
        setInSessionStorage(MODULE_ID, SELECTED_PLAN, finalPayload);
        props.history.push(ROUTES.B2B_SUMMARY, { plan: selectedPlan });
        setAPIFetechingState({ type: FETCH_SUCCESS });
      })
      .catch((err) => {
        handleAPIError(err);
      });
  };

  const updatePlanDetails = () => {
    fireAnalyticsOnProceedPlanButtonClick();
    let finalPayload = {};
    if (existingPlanDetails && existingPlanDetails != '') {
      setAPIFetechingState({ type: INITIATE_FETCHING });

      existingPlanDetails[0].planDetail = createPlanDetails();
      finalPayload = { UPDATE: existingPlanDetails };
      updateDslConnectionDetails(finalPayload)
        .then((response) => {
          setInSessionStorage(MODULE_ID, SELECTED_PLAN, existingPlanDetails);
          props.history.push(ROUTES.B2B_SUMMARY, { plan: selectedPlan });
          setAPIFetechingState({ type: FETCH_SUCCESS });
        })
        .catch((err) => {
          handleAPIError(err);
        });
    } else {
      addPlanDetails();
    }
  };

  const createPlanDetails = () => {
    let finalPlan = Object.assign({}, selectedPlan);
    if (selectedPlan.choosedARP !== DEFAULT_1_MONTH_PLAN) {
      let finalPlanPrice = Object.assign({}, finalPlan.price);
      finalPlan.additionalOffers.map((offer) => {
        if (offer.planPeriod === finalPlan.choosedARP) {
          finalPlanPrice.amount = offer.offerPrice;
          finalPlanPrice.otc = offer.otc;
        }
      });
      finalPlan.planPeriod = selectedPlan.choosedARP;
      finalPlan.choosedARP = selectedPlan.choosedARP;
      finalPlan.price = finalPlanPrice;
    } else {
      finalPlan.planPeriod = DEFAULT_1_MONTH_PLAN;
      finalPlan.choosedARP = DEFAULT_1_MONTH_PLAN;
    }
    finalPlan.additionalOffers = null;
    return finalPlan;
  };

  const handleAPIError = (error) => {
    let alertTitle = 'Oops!!! something went wrong. Please try after some time';
    let alertmsg = '';
    // to do - handle error
    if (error && error.response && error.response.status === '400') {
      alertmsg = error.response.data.errorMsg;
    } else {
      alertmsg = 'Oops!!! something went wrong. Please try after some time';
    }
    setAPIFetechingState({
      type: FETCH_ERROR,
      alertData: {
        alertTitle: alertTitle,
        alertmsg: alertmsg,
        showAlert: true
      }
    });
  };

  const onClose = () => {
    setAPIFetechingState({ type: 'default' });
  };

  const closeNetworkCoveragePopup = () => {
    setNetorkConverageStatus(false);
  };
  const toggelToastPopup = () => {
    scrollToTop();
    setNetorkConverageStatus(false);
    setToastMessage(!showToastMessage);
  };
  const checkToggelToastPopup = (data, skipChceckStatus) => {
    let returnStatus = false;
    if (data && !skipChceckStatus && data.status === LEAD_STATUS.FEASIBILITY_PENDING) {
      returnStatus = true;
      toastMessageValue = LEAD_STATUS_MSG.FEASIBILITY_PENDING;
    } else if (data && !skipChceckStatus && data.status === LEAD_STATUS.PNQ_IN_PROGRESS) {
      returnStatus = true;
      toastMessageValue = LEAD_STATUS_MSG.KAM_MG;
    } else if (data && !skipChceckStatus && data.status === LEAD_STATUS.PNQ_COMPLETED && data.doaStatus !== 'REJECTED') {
      returnStatus = true;
      toastMessageValue = LEAD_STATUS_MSG.PNQ_COMPLETED_MSG_CUSTOMER;
    } else if (data && skipChceckStatus && data.leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT && data.doaStatus !== 'CLARITY_REQUIRED') {
      returnStatus = true;
      if (data && data.doaAssignedToRole) {
        let doaDetails = data?.doaAssignedToUsers?.length ? data?.doaAssignedToUsers[0] : {};
        let approval = data.doaAssignedToRole && data.doaAssignedToRole.replace(/_/g, ' ');
        approval = approval.toLowerCase();
        toastMessageValue = `Your request has been sent successfully to  ${approval} ${doaDetails.name ? doaDetails.name : ''} (${doaDetails.email ? doaDetails.email : ''}, ${
          doaDetails.phoneNumber ? doaDetails.phoneNumber : ''
        }) for approval.`;
      } else {
        toastMessageValue = LEAD_STATUS_MSG.SENT_DOA_REQUEST_MSG;
      }
    } else if (data && skipChceckStatus && data.doaStatus === 'CLARITY_REQUIRED') {
      returnStatus = true;
      toastMessageValue = LEAD_STATUS_MSG.CLARITY_REQUIRED_MSG;
    }
    return returnStatus;
  };
  const getRouterData = (auth_token, getParams) => {
    getRouterList()
      .then((res) => {
        let responseData = res.data && res.data.result;
        setRouterLists(responseData);
        getKamLeadData(auth_token, getParams);
        setInSessionStorage(MODULE_ID, ROUTER_LISTS, responseData);
      })
      .catch((err) => console.error(err));
  };
  const checkLeadStatus = () => {
    let className = '';
    if (leadStatus === LEAD_STATUS.PRICING_APPROVAL_REQUEST_SENT && pnqLeadData && pnqLeadData.length > 0 && pnqLeadData[0] && pnqLeadData[0].doaStatus === 'CLARITY_REQUIRED') {
      className = 'leadDisabled enable-custome-price';
    } else if (
      leadStatus === LEAD_STATUS.FEASIBILITY_PENDING ||
      leadStatus === LEAD_STATUS.PNQ_IN_PROGRESS ||
      leadStatus === LEAD_STATUS.PNQ_CANCELED ||
      (paramsValue && paramsValue.user === 'KAM' && leadStatus && leadStatus !== LEAD_STATUS.REQUIRED_PRICE_NEGOTIATION)
    ) {
      className = 'leadDisabled';
    } else if (
      leadStatus === LEAD_STATUS.PNQ_COMPLETED &&
      leadDetails &&
      (leadDetails.doaStatus === 'APPROVED' || !leadDetails.doaStatus || leadDetails.doaStatus === 'AUTO_APPROVED')
    ) {
      className = 'leadDisabled submit-enabled';
    } else if ((leadDetails && leadDetails.doaStatus === 'REJECTED') || leadStatus === 'PRICING_DOA_REJECTED') {
      className = 'leadDisabled submit-enabled plan-enabled';
    } else if (leadStatus === LEAD_STATUS.PNQ_COMPLETED && leadDetails && leadDetails.doaStatus !== 'APPROVED') {
      className = 'leadDisabled';
    } else if (leadStatus === LEAD_STATUS.FEASIBILITY_COMPLETED && leadDetails && leadDetails.feasibilityStatus === 'NOT_FEASIBLE') {
      className = 'leadDisabled';
    }
    return className;
  };
  const toggleSelectPopUp = () => {
    setShowCustomPopup(false);
    navigateTo(config.kamTrackLeadPage);
  };

  const getMaxBandwidth = () => {
    let maxBandwidth = selectedPrimaryMedia?.maxBandwidth ?? localStorage.getItem('maxBandwidth');
    let changeMaxBandwidth = maxBandwidth?.split(' ');
    if (changeMaxBandwidth[1] == 'Gbps') {
      return parseInt(maxBandwidth) * 1024;
    } else {
      return parseInt(maxBandwidth);
    }
  };

  const fetchAllPlans = (pincode, payloadInfo = {}) => {
    let accessToken;
    let maxBandwidth = getMaxBandwidth();
    let segment = leadDetails && leadDetails.customer && leadDetails.customer.segment;
    let getPartyId = partyId ? partyId : leadDetails && leadDetails.customer && leadDetails.customer.partyId;
    if (props.isdedicatedJourney || aehToken) {
      accessToken = localStorage.getItem('accessToken') ? localStorage.getItem('accessToken') : '';
    }
    let feasibilityResponse = getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE);
    let feasibilityStatus = feasibilityResponse && feasibilityResponse.feasibilityStatus;
    if (!feasibilityStatus) {
      feasibilityStatus = leadDetails && leadDetails.feasibilityStatus;
    }
    let payload = { ...payloadInfo };
    if (props.isdedicatedJourney) {
      payload.pincode = pincode;
      payload.service = servicetype;
    } else {
      payload.pincode = pincode;
    }
    if (maxBandwidth && feasibilityStatus === 'FEASIBLE') {
      payload.maxBandwidth = maxBandwidth;
    }
    if (getPartyId && segment) {
      payload.partyId = getPartyId;
      payload.segment = segment;
    }
    fetchPlans(payload, props.isdedicatedJourney, accessToken)
      .then((response) => {
        let data = response && response.data;
        data.success &&
          setPlans(
            data.result.map((item, index) => {
              return { ...item, id: index, contractPeriod: contractOptions[0], media: selectedPrimaryMedia };
            })
          );
        setInSessionStorage(MODULE_ID, AVAILABLE_BANDWIDTH, convertBandwidthInMbps(data.result));
        setAPIFetechingState({ type: FETCH_SUCCESS });
      })
      .catch((err) => {
        handleAPIError(err);
      });
  };
  const checkSuccessStatus = () => {
    let status = '';
    if (
      (leadStatus === LEAD_STATUS.FEASIBILITY_PENDING && leadDetails) ||
      (pnqLeadData && pnqLeadData.length && pnqLeadData[0] && pnqLeadData[0].doaStatus === 'CLARITY_REQUIRED')
    ) {
      status = 'warning';
    } else {
      status = 'success';
    }
    return status;
  };

  const getNotificationData = () => {
    const { isdedicatedJourney, isUnAuthJourney } = props;

    let notificationType = WARNING_TOAST;
    let notificationTemplate = (
      <Fragment>
        <p className="text_color_bg">
          <span style={{ display: 'block' }}>Manual Network Check Required</span>
          {!isUnAuthJourney ? PLAN_PAGE_NOTIFICATIONS.MANUAL_CHECK : PLAN_PAGE_NOTIFICATIONS.DEFAULT}
        </p>
      </Fragment>
    );

    const feasibilityResponse = isdedicatedJourney ? getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE) : getFromSessionStorage(MODULE_ID, FEASIBILITY_RESPONSE);
    const feasibilityStatus = feasibilityResponse && feasibilityResponse.feasibilityStatus;
    const showFeasibilityStatus = leadDetails && leadDetails.feasibilityStatus ? leadDetails.feasibilityStatus : leadStatus ? leadStatus : '';
    const EXCELLENT_NETWORK =
      FEASIBILITY_STATUS.FEASIBLE_HIGH_CONFIDENCE.key === feasibilityStatus || showFeasibilityStatus === 'FEASIBLE' || showFeasibilityStatus !== 'MANUAL_INTERVENTION_REQUIRED'
        ? true
        : false;

    const maxBandwidth = localStorage.getItem('maxBandwidth');
    const media = localStorage.getItem('media');

    if (EXCELLENT_NETWORK) {
      notificationType = SUCCESS_TOAST;
      notificationTemplate = (
        <Fragment>
          <p className="text_color_bg">
            <span style={{ display: 'block' }}>Excellent network Coverage</span> Maximum speed of up to{maxBandwidth ? ' ' + parseInt(maxBandwidth) + 'Mbps' : ' 1Gbps'} available
            at your location via {media ? ' ' + media : 'fibre and copper cables'}.
          </p>
        </Fragment>
      );
    }

    return {
      type: notificationType,
      message: notificationTemplate
    };
  };

  const getNotificationState = () => {
    const notificationState = {
      show: false,
      type: '',
      message: '',
      eventHandler: () => {},
      onCancel: () => {}
    };

    const isNetworkCoverageNotification = showNetworkConverage && !showToastMessage;
    const plansNotification = showToastMessage && plans && plans.length > 0;

    // handle show
    if (isNetworkCoverageNotification || plansNotification) {
      notificationState.show = true;
    }

    // handle type
    if (isNetworkCoverageNotification) {
      notificationState.type = getNotificationType(getNotificationData().type);
    } else if (plansNotification) {
      notificationState.type = getNotificationType(checkSuccessStatus());
    }

    // handle message
    if (isNetworkCoverageNotification) {
      notificationState.message = getNotificationData().message;
    } else if (plansNotification) {
      notificationState.message = toastMessageValue ? toastMessageValue : LEAD_STATUS_MSG.KAM_MG;
    }

    // handle eventHandler
    if (isNetworkCoverageNotification) {
      notificationState.eventHandler = closeNetworkCoveragePopup;
    } else if (plansNotification) {
      notificationState.eventHandler = toggelToastPopup;
    }

    // handle onCancel
    if (isNetworkCoverageNotification) {
      notificationState.onCancel = closeNetworkCoveragePopup;
    } else if (plansNotification) {
      notificationState.onCancel = toggelToastPopup;
    }

    return notificationState;
  };

  return (
    <React.Fragment>
      {fetchState.loader ? (
        <div className="container round-loader">
          <MainLoader />
          <p className="loader-heading">
            <span className="color-red">Loading…</span>
            <br />
            Please Wait.
          </p>
        </div>
      ) : (
        <div className={`feasibility-requests position-relative ${checkLeadStatus()}`}>
          {!isProductPage && plans && plans.length > 0 && (
            <React.Fragment>
              <StepsHeader
                showCbftId
                showEmailProposal={paramsValue && paramsValue.user === 'KAM' ? false : true}
                selectedPlan={selectedPlan}
                userType={paramsValue && paramsValue.user}
                disabled={paramsValue && paramsValue.leadId}
                activeStepIndex={JOURNEY_STEPS_INDEX.CHOOSE_PLAN + 1}
                isdedicatedJourney={props.isdedicatedJourney}
                isUnAuthJourney={props.isUnAuthJourney}
                showFeasibilityStatus={leadDetails && leadDetails.feasibilityStatus ? leadDetails.feasibilityStatus : leadStatus ? leadStatus : ''}
              />
              <section id="notification">
                <Notification
                  show={getNotificationState().show}
                  type={getNotificationState().type}
                  message={getNotificationState().message}
                  eventHandler={getNotificationState().eventHandler}
                  onCancel={getNotificationState().onCancel}
                ></Notification>
              </section>
            </React.Fragment>
          )}
          {props.isdedicatedJourney && props.isUnAuthJourney && plans && plans.length > 0 && (
            <Quotation plans={plans} servicetype={servicetype} setservicetype={setservicetype} pincode={pincode} setactiveStep={setactiveStep} />
          )}
          {props.isdedicatedJourney && !props.isUnAuthJourney && plans && plans.length > 0 && (
            <DedicatedPlanPage
              commercialAttribute={commercialAttribute}
              setCommercialAttributes={setCommercialAttributes}
              submitLead={submitLead}
              setAPIFetechingState={setAPIFetechingState}
              getKamLeadData={getKamLeadData}
              plans={plans}
              servicetype={servicetype}
              setservicetype={setservicetype}
              setactiveStep={setactiveStep}
              kamDetails={kamDetails}
              fetchLead={fetchLead}
              leadDetails={leadDetails}
              leadStatus={leadStatus}
              setleadStatus={setLeadStatus}
              getLeadPlan={getLeadPlan}
              paramsValue={paramsValue}
              routerLists={routerLists}
              pnqLeadData={pnqLeadData}
              dualLastMile={dualLastMile}
              feasibilityData={feasibilityData}
              fetchPlansOrKAMData={fetchPlansOrKAMData}
              selectedPrimaryMedia={selectedPrimaryMedia}
              setSelectedPrimaryMedia={setSelectedPrimaryMedia}
              maxBandwidth={getMaxBandwidth()}
              itemCode={itemCode}
              setItemCode={setItemCode}
              rateCardIdList={rateCardIdList}
              setRateCardIdList={setRateCardIdList}
              selectedRateCardId={selectedRateCardId}
              setSelectedRateCardId={setSelectedRateCardId}
            />
          )}
          {!isProductPage && !props.isdedicatedJourney && (
            <React.Fragment>
              {changePlan ||
                (selectedPlan && selectedPlan.choosedARP && selectedPlan.choosedARP !== '' && (
                  <section className="button-section">
                    <div className="container">
                      <Button onClick={() => (!changePlan ? addPlanDetails() : updatePlanDetails())}>Proceed</Button>
                    </div>
                  </section>
                ))}
            </React.Fragment>
          )}
        </div>
      )}
      {showCustomPopup ? (
        <PopupComponent
          toggleSelectPopUp={toggleSelectPopUp}
          popupData={{
            title: POPUP_DATA.AUTO_APPROVED_TITLE,
            message: POPUP_DATA.AUTO_APPROVED_MSG,
            buttonYes: POPUP_DATA.AUTO_APPROVED_BTN_TXT
          }}
        />
      ) : (
        ''
      )}
    </React.Fragment>
  );
};
export default PlanPage;
